var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.999 10C17.999 14.4183 14.4173 18 9.99902 18C5.58075 18 1.99902 14.4183 1.99902 10C1.99902 5.58172 5.58075 2 9.99902 2C14.4173 2 17.999 5.58172 17.999 10ZM14.62 7.49701L13.5781 6.50299L8.34402 11.987L6.09025 9.88347L5.10779 10.9363L8.40396 14.0122L14.62 7.49701Z",
    fill: "#04B395"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.ff90d68c9fdb67196106baa6120ecdb5.svg";
export { ForwardRef as ReactComponent };